import { cva, type VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import { cn } from "@/core/utils/utils";
import { Stack } from "./ui/stack";

const spinnerVariants = cva("animate-spin", {
  variants: {
    size: {
      sm: "h-4 w-4",
      default: "h-10 w-10",
      lg: "h-16 w-16",
    },
    color: {
      default: "text-stroke-tabSelected",
      primary: "text-primary",
      secondary: "text-secondary-text",
      tertiary: "text-tertiary-text",
      interactive: "text-interactive-text",
      negative: "text-negative-text",
      inverse: "text-primary-inverse-text",
    },
  },
  defaultVariants: {
    size: "default",
    color: "default",
  },
});

type SpinnerVariantProps = VariantProps<typeof spinnerVariants>;

interface LoadingSpinnerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "size" | "color"> {
  className?: string;
  containerClassName?: string;
  size?: SpinnerVariantProps["size"];
  color?: SpinnerVariantProps["color"];
  flexHeight?: boolean;
}

export const LoadingSpinner = ({
  className,
  containerClassName,
  size,
  color,
  flexHeight,
  ...props
}: LoadingSpinnerProps) => (
  <Stack
    fullWidth
    className={cn(
      "items-center justify-center",
      flexHeight ? "flex-1" : "h-full",
      containerClassName,
    )}
    {...props}
  >
    <Loader2 className={cn(spinnerVariants({ size, color }), className)} />
  </Stack>
);
